<div class="col-md-12 no-padding">
    <div class="col-md-3 no-padding">
        <h5>Danas, {{datePipeString}}</h5>
    </div>
    <div class="col-md-9 text-right no-padding">
        <!--<h5><i class="fa fa-clock"></i>  6h 27m (8h 12m)</h5>-->
    </div>
</div>